import {emptyValidator, formValidator} from "../../validators";

const itemCreationValidationStatus = {
    temType: {
        validators: [emptyValidator()],
        name: "Type"
    },temStatus: {
        validators: [emptyValidator()],
        name: "Status"
    },temActive: {
        validators: [emptyValidator()],
        name: "Active"
    },temName: {
        validators: [emptyValidator()],
        name: "Name"
    },temUnit: {
        validators: [emptyValidator()],
        name: "Default Unit"
    },temPackageType: {
        validators: [emptyValidator()],
        name: "Package Type"
    },temPrice: {
        validators: [emptyValidator()],
        name: "Unit Price"
    },
    temPrefix: {
        validators: [emptyValidator()],
        name: "Prefix"
    },

}
export const itemCreationValidation = (temValidation) => {
    return formValidator(temValidation, itemCreationValidationStatus);
}

const approveDetailsValidationStatus = {

    userPermission:{
        validators : [emptyValidator()],
        name: "Permission",
    },
    // apdDepartments:{
    //     validators : [emptyValidator()],
    //     name: "Department",
    // },
    apdSeq:{
        validators : [emptyValidator()],
        name: "Sequence",
    },
    apdName:{
        validators : [emptyValidator()],
        name: "Name",
    }
}
export const approveDetailsValidation= (appValidation) => {
    return formValidator(appValidation, approveDetailsValidationStatus);
}

const approveHeaderValidationStatus = {

    appName:{
        validators : [emptyValidator()],
        name: "Name",
    },
    appApprovals:{
        validators : [emptyValidator()],
        name: "Approval Type",
    },
    appStatus:{
        validators : [emptyValidator()],
        name: "Status",
    },
    appActive:{
        validators : [emptyValidator()],
        name: "Active",
    }
}
export const approveHeaderValidation= (appValidation) => {
    return formValidator(appValidation, approveHeaderValidationStatus);
}

const deductionMasterStatus = {

    dedItemType:{
        validators : [emptyValidator()],
        name: "Item Type",
    },
    dedItem:{
        validators : [emptyValidator()],
        name: "Item",
    },
    dedVehicle:{
        validators : [emptyValidator()],
        name: "Vehicle",
    },
    dedTransporter:{
        validators : [emptyValidator()],
        name: "Transporter",
    },
    dedStatus:{
        validators : [emptyValidator()],
        name: "Status",
    },
    dedActive:{
        validators : [emptyValidator()],
        name: "Active",
    },
    dedPeriod:{
        validators : [emptyValidator()],
        name: "Period",
    },
    dedInstallments:{
        validators : [emptyValidator()],
        name: "Installment",
    },
    dedStart:{
        validators : [emptyValidator()],
        name: "Start",
    },
    dedEnd:{
        validators : [emptyValidator()],
        name: "End",
    },
    dedExecutionDate:{
        validators : [emptyValidator()],
        name: "Execution Date",
    },
    dedPaymentStatus:{
        validators : [emptyValidator()],
        name: "Payment Status",
    },
    dedSupplier:{
        validators : [emptyValidator()],
        name: "Supplier",
    },

}
export const deductionMasterValidation= (dedValidation) => {
    return formValidator(dedValidation, deductionMasterStatus);
}

const fuelAddStatus = {
    fDedPeriod:{
        validators: [emptyValidator()],
        name: "Period",
    },
    fDedItem:{
        validators: [emptyValidator()],
        name: "Item",
    },
    fDedSupplier:{
        validators: [emptyValidator()],
        name: "Supplier",
    },
    fDedVehicle:{
        validators: [emptyValidator()],
        name: "Vehicle",
    },
    fDedTransporter:{
        validators: [emptyValidator()],
        name: "Transporter",
    }
}
export const fuelAddValidation= (dedValidation) => {
    return formValidator(dedValidation, fuelAddStatus);
}

const deductionFuelStatus = {
    dedItemType:{
        validators : [emptyValidator()],
        name: "Item Type",
    },
    dedItem:{
        validators : [emptyValidator()],
        name: "Item",
    },
    dedVehicle:{
        validators : [emptyValidator()],
        name: "Vehicle",
    },
    dedTransporter:{
        validators : [emptyValidator()],
        name: "Transporter",
    },
    dedStatus:{
        validators : [emptyValidator()],
        name: "Status",
    },
    dedActive:{
        validators : [emptyValidator()],
        name: "Active",
    },
    dedPeriod:{
        validators : [emptyValidator()],
        name: "Period",
    },
    dedInstallments:{
        validators : [emptyValidator()],
        name: "Installment",
    },
    dedStart:{
        validators : [emptyValidator()],
        name: "Start",
    },
    dedEnd:{
        validators : [emptyValidator()],
        name: "End",
    },
    dedExecutionDate:{
        validators : [emptyValidator()],
        name: "Execution Date",
    },
    dedPaymentStatus:{
        validators : [emptyValidator()],
        name: "Payment Status",
    },
    dedJob:{
        validators: [emptyValidator()],
        name: "Job",
    }
}
export const deductionFuelValidation = (dedValidation) => {
    return formValidator(dedValidation, deductionFuelStatus);
}
